import React from 'react';
import { useEffect, useState } from 'react';
import { renderRichText } from 'gatsby-source-contentful/rich-text';

import * as styles from './countdown.module.css';


const getReturnValues = (countdown) => {
  // if (countdown === null) return [null, null, null, null];
  // calculate time left
  const days = Math.floor(countdown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countdown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((countdown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countdown % (1000 * 60)) / 1000);

  return [days, hours, minutes, seconds];
};

const useCountdown = (targetDate) => {
  const [countdown, setCountdown] = useState(null);

  // TODO: Note when target date is null, return 0
  // TODO: Check that we are actually doing building stuff or not as idk if we are

  useEffect(() => {
    const countdownDate = new Date(targetDate).getTime();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const timeToWait = countdownDate - now;
      console.log('TIME:', now)
      setCountdown(timeToWait > 0 ? timeToWait : 0);
    };

    updateCountdown(); // Initialize the countdown immediately

    // If the target date has already passed at BUILD TIME, then return
    // the openElement.
    // Note: This code will run once, at buildtime, which GatsbyJS will use
    // to create the static element on the site. This will not make it dynamic.
    if (countdown === 0) {
      console.log('COUNTDOWN EQUALS 0')
      return;
    }
    // Otherwise, all rendering must happen in the browser at RUNTIME, so the
    // countdown timer updates accurately.
    // Note: Window only exists in the browser, so this will only work at runtime.
    if (typeof window !== "undefined") {
      console.log('WINDOW DEFINED')
      const interval = setInterval(updateCountdown, 1000);

      return () => clearInterval(interval);
    }
  }, [targetDate]);

  console.log('RETURN VALUES');
  return getReturnValues(countdown);
};

const DateTimeDisplay = ({ value, type, isDanger }) => {
  return (
    <div className={isDanger ? `${styles.countdown} ${styles.danger}` : `${styles.countdown}`}>
      <p>{value}</p>
      <span>{`${type}${value > 1 || value === 0 ? 's' : ''}`}</span>
    </div>
  );
}

const TimerDisplay = ({
  days,
  hours,
  minutes,
  seconds
}) => {
  return (
    <div className={styles.countdownWrapper}>
      <DateTimeDisplay value={days} type={'Day'} isDanger={days <= 3} />
      <p>:</p>
      <DateTimeDisplay value={hours} type={'Hour'} isDanger={days < 1 && hours <= 24} />
      <p>:</p>
      <DateTimeDisplay value={minutes} type={'Min'} isDanger={days < 1 && hours < 1} />
      <p>:</p>
      <DateTimeDisplay value={seconds} type={'Second'} isDanger={days < 1 && minutes < 1} />
    </div>
  );
}

const Countdown = ({
  preAccessMessage,
  targetDate,
  openElement
}) => {
  const [days, hours, minutes, seconds] = useCountdown(targetDate);
  console.log('Times:', days, hours, minutes, seconds)
// seconds && 
  if (days + hours + minutes + seconds <= 0) {
    console.log('TIMER EXPIRED', days, hours, minutes, seconds)
    return openElement;
  } else {
    return (
      <div className={styles.container}>
        {preAccessMessage?.raw && (
          <div className={styles.preAccessMessage}>
            {renderRichText(preAccessMessage)}
          </div>
        )}
        <TimerDisplay
          days={days}
          hours={hours}
          minutes={minutes}
          seconds={seconds}
        />
      </div>
    );
  }
};

export default Countdown;
